import jQuery from 'jquery';

const FIRST_INDEX = 0;

const getPreviewWarning = () => {
  const warningText =
    'Note: some links may not work in preview but will work as expected on the published page';

  const warningLabel =
    jQuery(`<div class="click-action-note url-note">${warningText}</div>`)[FIRST_INDEX];

  warningLabel.hide();

  return warningLabel;
};

export default getPreviewWarning;


// WEBPACK FOOTER //
// ./src/ui/labels/preview-warning.js